<template>
  <div
    class="testContainer body-bg"
    :class="{isnotShowTit:type!==0?true:false}"
  >
    <mt-header
      fixed
      title=""
    >
      <div slot="left">
        <mt-button router-link="'/'">{{myPageTit}}</mt-button>
      </div>
    </mt-header>
    <div
      class="testCon"
      v-if="!isHasdata"
    >
      <div class="timer clearfix">
        <div class="fl">
          <p
            v-show="questionitem.number>1"
            @click="GetPreQuestionItem"
          >上一题</p>
        </div>
        <div
          class="fl"
          style="width:60%;color:#666;font-size:0.24rem;"
        >倒计时：<span>{{rest}}</span></div>
        <div class="fr">
          <p
            v-show="questionitem.number < questioncount"
            @click=" GetNextQuestionItem"
          >下一题</p>
        </div>
      </div>
      <div class="questionCon">
        <div class="qName">{{questionitem.number}}.
          <span class="qType">{{questionitem.type}}</span> {{questionitem.title}}
        </div>
        <div
          class="qImg"
          v-if="questionitem.qimge!== '' && questionitem.qimge!== null && questionitem.qimge!== undefined "
        >
          <img
            :src="questionitem.qimge"
            alt=""
          >
        </div>
        <ul>
          <li
            class="mnt-ans"
            v-for="(item,index) in answeritems"
            :key="index"
            v-on:click="selectanswer(index)"
            v-bind:class="{'active':item.isChecked == true}"
          >
            <i>{{(index+1) | testItemFormate}}</i>{{item.selectitem}}
          </li>
        </ul>
        <mt-button
          type="default"
          class="sureBtn"
          @click="submitexambynumber"
          v-if="questionitem.type === ' 多选题 '  || questionitem.type === '案例分析'"
        >确定</mt-button>
      </div>
      <div v-if="showanswer">
        <div  class="questionCon ansBox"  v-show="showAns"  >
          <ul class="clearfix">
            <li class="fl">答案：<span class="rightAns">{{rightAns}}</span></li>
            <li class="fl">您选择：<span style="color:#999">{{myAns==0?"-":myAns}}</span>
            </li>
          </ul>
        </div>
      </div>

      <ul class="clearfix czBtn">
        <li class="fl">
          <img
            src="../assets/imgs/testCard.png"
            alt=""
            @click="toggleShow()"
          >
        </li>
        <li class="fl" v-show='showbut'>
          <img
            src="../assets/imgs/submitTest.png"
            alt=""
            @click="SubmitExam(false)"
          >
        </li>
      </ul>
      <p class="pages">{{questionitem.number}}/{{questioncount}}</p>
    </div>
    <mt-popup
      v-model="popupVisible"
      position="bottom"
      class="panle"
    >
      <ul class="panleTop clearfix">
        <li class="fl">已答:{{doneQ}}</li>
        <li class="fl">未答:{{questioncount - doneQ}}</li>
      </ul>
      <div class="ansCon">
        <dl class="testNums">
          <dd
            v-for="(item,i) in items"
            :key="i"
            v-on:click="fn(i,item.isright)"
          >
          <span v-if="showanswer" :class="{'error': item.isright == false,'done': item.isright == true,'mnt-now':changebackcolor == i && item.isright == null }">{{i+1}}</span>
          <span v-else :class="{'done': item.isright != null,'mnt-now':changebackcolor == i && item.isright == null }">{{i+1}}</span>
          </dd>
        </dl>
      </div>
      <div
        class="shouqi"
        @click="toggleShow()"
      >收起</div>
    </mt-popup>
    <div
      class="maskTest"
      v-show='isShowMask'
    ></div>
    <div
      class="testToast"
      v-show='isShowNO'
    >
      很遗憾，您未通过考试
      <img
        src="../assets/imgs/testFail.png"
        alt=""
      >
      <div>考试成绩：{{correctcount}}分</div>
      <div
        class="backH"
        @click="toBackH()"
      >确定</div>
    </div>
    <div
      class="testToast"
      v-show='isShowYES'
    >
      恭喜你考试合格
      <img
        src="../assets/imgs/testSuccess.png"
        alt=""
      >
    <div>考试成绩：{{correctcount}}分</div>
      <div
        class="backH"
        @click="toBackH()"
      >确定</div>
    </div>
    <div
      v-if="isHasdata"
      class="noData"
    >
      <img
        src="../assets/imgs/noDate.png"
        alt=""
      >
      <p>考题加载失败，请联系系统管理员</p>
    </div>
  </div>
</template>

<script>
import { getTestConfigs, getTestInfos, saveTestInfos } from '../../src/api/Api'
import { Toast, MessageBox,Indicator } from 'mint-ui'
var video1
export default {
  data () {
    return {
      type: Number(this.$route.query.type), // app上不显示标题
      platform: Number(this.$route.query.platform), // 平台id
      studyplanid: Number(this.$route.query.studyplanid), // 计划id
      MarkofOne:  Number(this.$route.query.platform) === 0 ? 5
                : Number(this.$route.query.platform) === 1 ? 10
                : Number(this.$route.query.platform) === 2 ? 10
                : Number(this.$route.query.platform) === 3 ? 10
                : Number(this.$route.query.platform) === 4 ? 1 : 0,
      stuId: this.$route.query.stuid, // 学员id
      showanswer: this.$route.query.showanswer==1, // 是否显示答案  0不显示 1显示
      myPageTit: '考试',
      isHasdata: false,
      popupVisible: false,
      alltime: 0, // 出题时间
      passScores: 0, // 考试合格成绩
      endTime: null,
      QuestionList: [], // 所有试题
      ansItems: [], // 试题
      questioncount: '', // 总共多少道题
      currentNum: 1, // 当前题号
      nowquestionindex: 0, // 试题索引
      answeritems: [], // 试题答案选项
      items: [], // 答案区展示列表
      changebackcolor: '',
      choosedId: null, // 选中答案id
      correctcount: 0, // 对了几题
      score: 0, // 分数
      doneQ: 0,
      showAns: false, //是否显示答案
      rightAns: '', //正确选项
      myAns: 0, //我的选项
      isPass: 0, // 是否开始通过
      ST: '', // 考试开始时间
      ET: '', // 考试结束时间
      isShowMask: false, // 考试结果-遮罩
      isShowNO: false, // 考试结果-未通过
      isShowYES: false, // 考试结果-通过
      mulitem: '', // 多选
      paperData: {
        name: '', // 考试名称
        time: '', // 考试时间
        totalPoints: '', // 考试总分
        mcFraction: '1', // 单选题分数(单个题)
        mcQFraction: '1', // 多选题分数(单个题)
        caFraction: '5', // 案例分析分数(单个题)
        judgmentFraction: '1' // 判断题分数(单个题)
      },
      questionitem: {
        number: '', // 题号
        title: '', // 题目
        type: '', // 试题类型
        answerlist: '', // 试题选项
        qimge: ''
      },
      baseUrl: window.baseapi.baseApiUrl, // 继续教育
      ZXbaseApiUrl: window.baseapi.ZXbaseApiUrl, // 专项学习
      AQXXbaseApiUrl: window.baseapi.AQXXbaseApiUrl, // 安全学习
       showbut:true//是否显示提交按钮
    }
  },
  filters: {
    testItemFormate (val) {
      switch (val) {
        case 1:
          return 'A'
          break
        case 2:
          return 'B'
          break
        case 3:
          return 'C'
          break
        case 4:
          return 'D'
          break
        case 5:
          return 'E'
          break
        case 6:
          return 'F'
          break
      }
    }
  },
  created () {
    if (
      this.$route.query.stuid !== null &&
      this.$route.query.stuid !== '' &&
      this.$route.query.stuid !== undefined
    ) {
      this.stuId = this.$route.query.stuid
    }

    sessionStorage.setItem('platform', this.platform) // 继续教育0  专项学习1
    this.$store.dispatch('SetPlatform', this.platform)
  },
  mounted () {
    console.log(this.$route.query.showanswer)
    console.log(this.showanswer)
     if(this.showanswer){
       this.myPageTit="模拟"
     }
    // 确保dom元素加载后再执行方法

    // let con=document.getElementsByClassName("questionCon")[0]
    // console.log(window.innerHeight+'~~~!~!~!~!~!')
    // con.style.height= (window.innerHeight -229) *0.01+'rem'
    this.ST = this.dateFormat()
    console.log('开始时间戳' + this.ST)
    this.getQuestions(0)
  },
  methods: {
    fn: function (i,type) {
      if(type!=null&&this.showanswer){
         this.showAns=true;
      }else{
        this.showAns=false;
      }
      this.changebackcolor = i
      this.nowquestionindex = i
      this.getquestionItem(i)
      this.getexamchange()
      this.popupVisible = !this.popupVisible
    },
    toggleShow () {
      this.popupVisible = !this.popupVisible
    },
    fomart (time) {
      var h, m, s
      h = Math.floor(time / 3600)
      m = Math.floor((time / 60) % 60)
      s = Math.floor(time % 60)
      h < 10 ? (h = '0' + h) : (h = h)
      m < 10 ? (m = '0' + m) : (m = m)
      s < 10 ? (s = '0' + s) : (s = s)
      return h + ':' + m + ':' + s
    },
    GetTestConfigs () {
      // 考试配置项
      getTestConfigs({stuId:this.stuId}).then(res => {
        if (res.data.returnCode === 1) {
          this.passScores = res.data.returnDate.passmark
          this.alltime = Number(res.data.returnDate.examtime) * 60
          console.log(this.alltime + '@@@' + this.passScores)
          var that = this
          var time = that.alltime
          this.timer = setInterval(function () {
            time = time - 1
            that.endTime = time
            if (time === 0&&this.showbut) {
              clearInterval(that.timer)
              Toast('考试时间结束！3秒后将自动提交')
              setTimeout(() => {
                that.SubmitExam(true)
              }, 3000)
            }
          }, 1000)
        }
      })
    },
    GetPreQuestionItem () {
      // 上一题
      this.showAns = false
      this.nowquestionindex--
      this.changebackcolor = this.nowquestionindex
      this.getquestionItem(this.nowquestionindex)
      this.getexamchange()
    },
    GetNextQuestionItem () {
      // 下一题
      this.showAns = false
      this.nowquestionindex++
      this.changebackcolor = this.nowquestionindex
      this.getquestionItem(this.nowquestionindex)
      this.getexamchange()
    },
    getexamchange () {
      // 换题
      var _this = this
      var item = this.items[this.nowquestionindex]
      if (item.isright !== null) {
        _this.answeritems.forEach(x => {
          x.hasexamed = true
        })
      }
    },
    getQuestions (nowquestionindex) {
      Indicator.open();
      getTestInfos({studyplanid:this.studyplanid,stuId:this.stuId}).then(res => {
        Indicator.close();
        if (res.data.code === 200) {
          debugger
          this.isHasdata = false
          this.QuestionList = res.data.data
          this.questioncount = this.QuestionList.length // 试题数量
          if(this.QuestionList.length==10&&this.MarkofOne==5){
            this.MarkofOne=10
          }
          if(this.QuestionList.length==50){
            this.MarkofOne=2
          }
          if(this.QuestionList.length==100){
            this.MarkofOne=1
          }
          // 加载答案选项
          var answerarray = []
          var qcount = this.questioncount + 1
          for (var j = 1; j < qcount; j++) {
            var arrayjosn = {
              type:this.QuestionList[j-1].type,
              isright: null,
              title: '',
              Id: j
            }
            answerarray.push(arrayjosn)
          }
          this.items = answerarray
          this.getquestionItem(nowquestionindex)
          this.GetTestConfigs()
        } else {
          this.isHasdata = true
        }
      });

    },
    getquestionItem (questionindex) {
      var check=[]
      // 根据索引获取试题
      var _this = this
      var QuestionItem = _this.QuestionList[questionindex]
      _this.questionitem.type = QuestionItem['type'] // 题型
      _this.questionitem.number = questionindex + 1 // 题号
      _this.questionitem.title = QuestionItem['questionsName'] // 试题
      _this.questionitem.qimge = QuestionItem['qimge'] // 试题
      _this.questionitem.answerlist = QuestionItem['questionitem'].split(',') // 答案选项列表
      if (QuestionItem['type'] === 1) {
        _this.questionitem.type = ' 单选题 '
      } else if (QuestionItem['type'] === 2) {
        _this.questionitem.type = ' 多选题 '
      } else if (QuestionItem['type'] === 3) {
        _this.questionitem.type = ' 判断题 '
      }else if (QuestionItem['type'] === 4) {
        _this.questionitem.type = '案例分析'
      }
      // 加载试题选项按钮
      var objectanswer = []
      var ArrayAnswer = _this.questionitem.answerlist // 选项
      for (var i = 0; i < ArrayAnswer.length; i++) {
        var ifin = -1
        if (this.items.length > 0) {
          // 做过了
          ifin = this.items[this.nowquestionindex].title.indexOf(ArrayAnswer[i])
        }
        var answeritem = {
          hasexamed: this.items.length > 0 && ifin != -1,
          selectitem: ArrayAnswer[i],
          isChecked: this.items.length > 0 && ifin != -1,
           index: i,
          rightanswer: null
        }
        if(ifin!=-1){
          check.push(i)
        }
        objectanswer.push(answeritem)
      }
      _this.answeritems = objectanswer
      if(this.showAns&&check.length>0){
        if (_this.questionitem.type === ' 多选题 '||_this.questionitem.type === '案例分析') {
          // for(var i=0;i<check.length;i++){
          //   this.selectanswer(check[i])
          // }
          _this.submitexambynumber()
        }else{
          this.selectanswer(check[0])
        }
      }
    },
    selectanswer: function (answeritem) {
      // 选择答案
      var _this = this
      var examtype = ''
      var item = _this.answeritems[answeritem].selectitem
      if (_this.questionitem.type === ' 多选题 ' || _this.questionitem.type === '案例分析') {
        if (this.answeritems[answeritem].isChecked === true) {
          this.answeritems[answeritem].isChecked = false
        } else {
          this.answeritems[answeritem].isChecked = true
        }
      } else {
        _this.myAns = _this.getitembyselect(answeritem + 1)
         _this.QuestionList[_this.nowquestionindex]['myAns']= _this.answeritems[answeritem].selectitem
      // 正确答案
        if (
          _this.QuestionList[_this.nowquestionindex]['answer'] ===
          _this.answeritems[answeritem].selectitem
        ) {
          console.log(
            '你选择的是：' +
              this.answeritems[answeritem].selectitem +
              '正确答案是' +
              this.QuestionList[this.nowquestionindex]['answer']
          )
          // console.log(this.answeritems)
          _this.answeritems.forEach(v => {
            if (
              v.selectitem ===
              _this.QuestionList[_this.nowquestionindex]['answer']
            ) {
              _this.rightAns = _this.getitembyselect(v.index + 1)
              _this.answeritems[answeritem].rightanswer = true
              console.log('单选答案---' + _this.rightAns)
            }
          })
        } else {
          _this.answeritems[answeritem].rightanswer = false
          _this.answeritems.forEach(v => {
            if (
              v.selectitem ===
              _this.QuestionList[_this.nowquestionindex]['answer']
            ) {
              _this.rightAns = _this.getitembyselect(v.index + 1)
              v.rightanswer = true
              console.log('单选答案++++' + _this.rightAns)
            }
          })
        }
// ----------------------------------------------------
        if (this.answeritems[answeritem].isChecked === true) {
          this.answeritems.forEach(k => {
            if (k !== this.answeritems[answeritem]) {
              k.isChecked = false
            }
          })
        } else {
          this.answeritems[answeritem].isChecked = true
          this.answeritems.forEach(k => {
            if (k !== this.answeritems[answeritem]) {
              k.isChecked = false
            }
          })
        }
        // this.showAns = true
      }
      if (_this.questionitem.type === ' 多选题 ' || _this.questionitem.type === '案例分析') {
        examtype = '2'
        // 如果存在已经选择的则去除
        if (_this.mulitem.indexOf(item) !== -1 && _this.mulitem.length > 0) {
          _this.mulitem = _this.mulitem.replace(item, '')
          _this.items[_this.nowquestionindex].title = _this.mulitem.trim()
        } else {
          _this.mulitem += item + ','
          _this.items[_this.nowquestionindex].title = _this.mulitem
        }
      }
      if (examtype !== '2') {
        _this.mulitem = ''
        _this.items[_this.nowquestionindex].title = item
        _this.submitexambynumber()
      }
    },
     getitembyselect (val) {
      switch (val) {
        case 1:
          return 'A'
          break
        case 2:
          return 'B'
          break
        case 3:
          return 'C'
          break
        case 4:
          return 'D'
          break
        case 5:
          return 'E'
          break
        case 6:
          return 'F'
          break
      }
    },
    submitexambynumber () {
      var _this = this
       var mutiselectitem = ''
      var rightanswer = ''
      if (_this.questionitem.type === ' 多选题 ' || _this.questionitem.type === '案例分析') {
        var sitem = ''
        _this.answeritems.forEach(x => {
          if (x.isChecked) {
            sitem += x.selectitem + ','
            mutiselectitem += this.getitembyselect(x.index + 1) + ','

          }
          var rights = _this.QuestionList[_this.nowquestionindex][
            'answer'
          ].split(',')
          // console.log(rights)
          rights.forEach(r => {
            if (r === x.selectitem) {
              rightanswer += _this.getitembyselect(x.index + 1)
              x.rightanswer = true
            } else {
              if (x.isChecked) {
                x.rightanswer = false
              }
            }
          })
          _this.rightAns = rightanswer
          // console.log('正确答案' + rightanswer)
        })
        _this.items[_this.nowquestionindex].title = sitem.substring(
          0,
          sitem.lastIndexOf(',')
        )
          _this.myAns = mutiselectitem.substring(
          0,
          mutiselectitem.lastIndexOf(',')
        )
         _this.QuestionList[_this.nowquestionindex]['myAns']=  sitem.substring(
           0,
           sitem.lastIndexOf(',')
         )
      }
      var answerarray = _this.items[_this.nowquestionindex].title
      var tempArray = _this.QuestionList
      var questionitem = tempArray[_this.nowquestionindex]
      if (questionitem['answer'] === answerarray) {
        _this.items[_this.nowquestionindex].isright = true
          if (_this.questionitem.type === ' 多选题 ' || _this.questionitem.type === '案例分析') {
          _this.rightAns = mutiselectitem.substring(
            0,
            mutiselectitem.lastIndexOf(',')
          )
        }
      } else {
        _this.items[_this.nowquestionindex].isright = false
      }
      this.CoungtScore(_this.questionitem.type)
      // this.showAns = true
      if (_this.nowquestionindex < _this.items.length - 1) {
        // 不是最后一题 就自动跳到下一题
        if(!this.showanswer){
           setTimeout(() => {
            _this.GetNextQuestionItem()
          }, 300)
        }

      } else {
        var dones = document.querySelectorAll('.done').length;
        if (dones === _this.items.length) {
          // 最后一题是多选题，且做完了
          MessageBox({
            title: '提示',
            message: '题做完了，要交卷吗?',
            showCancelButton: true,
            confirmButtonText: '确定',
            cancelButtonText: '取消'
          }).then(action => {
            if (action === 'confirm') {
              // 确认的回调
              this.commitanswer()
            } else {
              return false
            }
          })
        }
      }
    },
    CoungtScore (type) {
      this.correctcount = 0
      this.doneQ = 0
      this.items.forEach(k => {
        if (k.isright === true) {
           if (k.type === 4){
             this.correctcount += this.MarkofOne*5 // 每道题分数
           }else{
             this.correctcount += this.MarkofOne // 每道题分数
           }

        }
        if (k.title !== '') {
          this.doneQ++
        }
      })
      console.info(
        this.items.length +
          '当前得分：' +
          this.correctcount +
          '@@@index:' +
          this.nowquestionindex
      )
    },
    /**
     * 提交试卷
     */
    SubmitExam (isTimeout) {
      // 判断是否是超时导致
      if (isTimeout) {
        this.commitanswer()
      } else {
        MessageBox({
          title: '提示',
          message: '是否确认交卷?',
          showCancelButton: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(action => {
          if (action === 'confirm') {
            // 确认的回调
            this.commitanswer()
          } else {
            return false
          }
        })
      }
    },
    commitanswer () {
      this.ET = this.dateFormat()
      console.log('结束时间戳' + this.ET)

      // 判断是否通过考试
      var _this = this
      if (_this.loginstate !== '1') {
        if (_this.correctcount >= _this.passScores) {
          // Toast('恭喜您考试成绩合格')
          _this.isPass = 1
        } else {
          // Toast('您本次考试成绩为:' + _this.correctcount + '分，未达到合格分数，未通过考试')
          _this.isPass = 0
        }
      }
      // var apiurls = this.baseUrl
      // if (this.platform === 1) {
      //   apiurls = this.ZXbaseApiUrl
      // }
      // if (this.platform === 3) {
      //   apiurl = this.AQXXbaseApiUrl
      // }
      // this.$axios({
      //   method: 'get',
      //   url: apiurls + '/tbQuestionExam/submitExam',
      //   params: {
      //     studentid: _this.stuId,
      //     mark: _this.correctcount,
      //     starttime: _this.ST,
      //     endtime: _this.ET,
      //     ispass: _this.isPass,
      //     studyplanid:_this.studyplanid
      //   }
      // }).then(res => {
      //   if (res.data.returnCode === 200) {
      //     console.log('提交成功' + res.data.returnMsg)
      //     if (_this.isPass) {
      //       _this.isShowMask = true
      //       _this.isShowYES = true
      //     } else {
      //       _this.isShowMask = true
      //       _this.isShowNO = true
      //     }
      //   }
      // })
      // 保存成绩
      Indicator.open();
      saveTestInfos({
        studentid: _this.stuId,
        mark: _this.correctcount,
        starttime: _this.ST,
        endtime: _this.ET,
        ispass: _this.isPass,
        studyplanid:_this.studyplanid,
        testDetails:JSON.stringify(_this.QuestionList)
      }).then(res => {
        Indicator.close();
        if (res.data.returnCode === 200) {
          console.log('提交成功' + res.data.returnMsg)
          if (_this.isPass) {
            _this.isShowMask = true
            _this.isShowYES = true
          } else {
            _this.isShowMask = true
            _this.isShowNO = true
          }
        }
      })
    },
    toBackH () {
      if(!this.showanswer){
        switch (this.type) {
                case 0: // 微信
                  this.$router.push({
                    path: '/eEnter'
                  })
                  break
                case 1: // android
                  register_js.register('')
                  break
                case 2: // ios
                  nativeMethod.back()
                  break
                case 3: // ios
                  window.webkit.messageHandlers.toBackH.postMessage('')
                  break
              }
      }else{
        this.isShowYES=false
        this.isShowNO=false
        this.isShowMask=false
        this.showbut=false
      }

    },
    dateFormat () {
      var date = new Date()
      var year = date.getFullYear()
      /* 在日期格式中，月份是从0开始的，因此要加0
       * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
       * */
      var month =
        date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1
      var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      var hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
      var minutes =
        date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
      var seconds =
        date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      // 拼接
      return (
        year +
        '-' +
        month +
        '-' +
        day +
        ' ' +
        hours +
        ':' +
        minutes +
        ':' +
        seconds
      )
    }
  },
  computed: {
    rest () {
      return this.fomart(this.endTime)
    }
  },
  destroyed () {
    console.log('xioahui')
    Indicator.close();
    // Toast('返回将视为自动交卷')
  }
}
</script>

<style scoped>
#app {
  padding-top: 0;
}
body {
  background: #f2f2f2;
}
.isnotShowTit {
  top: 0;
}
.isnotShowTit .mint-header {
  display: none;
}
/* .body-bg{
  height: auto;
} */
.testContainer {
  padding: 0 0.15rem;
  width: 100%;
  box-sizing: border-box;
}
.timer > div {
  width: 20%;
  color: #92b8fe;
  height: 0.4rem;
}
.testNums {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding-bottom: 0.4rem;
}
.testNums dd {
  flex: 0 0 20%;
  padding: 0.2rem;
  height: 0.56rem;
  box-sizing: border-box;
  text-align: center;
  margin: 0.1rem 0;
}
.testNums dd span {
  height: 0.56rem;
  line-height: 0.56rem;
  box-sizing: border-box;
  border: 1px solid #ccc;
  text-align: center;
  width: 100%;
  display: inline-block;
  border-radius: 0.28rem;
  color: #666;
}
.testNums dd span.done {
  background: #80c269;
  border-color: #80c269;
  color: #fff;
}
.testNums dd span.mnt-now {
  background: #addc9d;
  border-color: #addc9d;
  color: #fff;
}
.ansCon {
  height: 88%;
  overflow: auto;
}
.shouqi {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 0.96rem;
  line-height: 0.96rem;
  background: #fff;
  border-top: 1px solid #dcdcdc;
  text-align: center;
  color: #999;
}
.testContainer .panle {
  width: 100%;
  background: #fff;
  top: 0.9rem;
  bottom: 0;
  padding-bottom: 0.96rem;
}
.panleTop {
  background: #92b8fe;
  height: 1.2rem;
  line-height: 1.2rem;
  text-align: center;
  color: #fff;
}
.panleTop .fl {
  width: 50%;
}
.testContainer .mint-cell::before {
  border: none;
}
.czBtn {
  margin: 0.9rem auto 0.2rem;
}
.czBtn .fl {
  width: 50%;
  text-align: center;
}
.czBtn img {
  width: 0.6rem;
  height: 0.6rem;
}
.testContainer .pages {
  color: #ccc;
  font-size: 0.24rem;
  text-align: center;
  margin-bottom: 0.3rem;
}
.mnt-ans {
  line-height: 0.4rem;
  margin: 0.4rem 0;
  color: #666;
}
.mnt-ans i {
  font-style: normal;
  width: 0.4rem;
  height: 0.4rem;
  text-align: center;
  line-height: 0.4rem;
  border-radius: 100%;
  border: 1px solid #999;
  background: #fff;
  color: #666;
  display: inline-block;
  margin-right: 0.2rem;
  font-size: 0.26rem;
}
.mnt-ans.active {
  color: #92b8fe;
}
.mnt-ans.active i {
  background: #92b8fe;
  border: 1px solid #92b8fe;
  color: #fff;
}
.maskTest {
  background: rgba(0, 0, 0, 0.3);
  color: #fff;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  z-index: 2;
}
.testNums dd span.error{
    background: #ff1740;
  color: #fff;
}
.testToast {
  width: 4rem;
  height: 4rem;
  background: #fff;
  border-radius: 0.1rem;
  position: fixed;
  z-index: 333;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  padding: 0.75rem;
  color: #92b8fe;
  text-align: center;
}
.testToast img {
  width: 2.28rem;
  height: 2.02rem;
  display: block;
  margin: 0.35rem auto 0.54rem;
}
.backH {
  height: 0.56rem;
  line-height: 0.56rem;
  width: 2.02rem;
  text-align: center;
  color: #fff;
  background: linear-gradient(
    240deg,
    rgba(146, 184, 254, 1),
    rgba(121, 160, 231, 1)
  );
  border-radius: 0.28rem;
  margin: 0 auto;
}
.timer {
  color: #666;
  font-size: 0.3rem;
  padding: 0 0.2rem;
  text-align: center;
  height: 1.28rem;
  line-height: 1.28rem;
}
.timer span {
  color: #333;
  font-size: 0.3rem;
}
.qType {
  border-radius: 0.1rem;
  background: #92b8fe;
  color: #fff;
  font-size: 0.2rem;
  padding: 0.05rem 0.1rem;
  line-height: 0.28rem;
  vertical-align: middle;
  margin-right: 0.2rem;
}
.questionCon {
  font-size: 0.3rem;
  line-height: 0.44rem;
  background: #fff;
  padding: 0.3rem;
}
.sureBtn {
  width: 2.28rem;
  height: 0.56rem;
  background: rgba(146, 184, 254, 1);
  border-radius: 0.1rem;
  margin: 0.8rem auto 0;
  color: #fff;
  font-size: 0.3rem;
  display: block;
}
.mint-msgbox-message {
  text-align: center;
}
.mnt-ans.dAns i {
  background: url(../assets/imgs/rAns.png) no-repeat center;
  background-size: cover;
  color: transparent;
}
.mnt-ans.cAns i {
  background: url(../assets/imgs/cAns.png) no-repeat center;
  background-size: cover;
  color: transparent;
}
.testResult {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin-top: 1rem;
}
.testResult p {
  color: #666;
  text-align: center;
}
.testResult .allTi {
  font-size: 0.6rem;
  color: #333;
}
.testResult .dTi {
  font-size: 0.6rem;
  color: #6da0f3;
}
.testResult .cTi {
  font-size: 0.6rem;
  color: #ff2a00;
}
</style>



// WEBPACK FOOTER //
// src/views/Test.vue